// Thin GA4 helper. Loading of gtag.js and the `config` call happen in
// /app/frontend/public/index.html so tracking is available before React
// hydrates. This file only provides safe wrappers used by React code.
//
// Safety rules:
//   - No PII is ever passed to gtag. Callers must not include names, emails,
//     phone numbers, form contents, or free-text.
//   - All calls are no-ops if window.gtag is missing (e.g. ad-blocker).
//   - Route tracking uses page_path + page_title only (no query params that
//     could contain PII are stripped here; do not put PII in URLs).

export const GA_MEASUREMENT_ID = 'G-F5BHXB60J1';

/** Fire a manual page_view for the current SPA route. */
export function trackPageView(pathname, search = '') {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', {
    page_path: pathname + (search || ''),
    page_location: window.location.href,
    page_title: document.title,
  });
}

/** Fire an arbitrary GA4 event. `params` MUST NOT contain PII. */
export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
}

/**
 * Registration funnel helpers. These are exported for the future
 * Customer/Vendor Portal — no public registration flow exists today, so
 * neither helper is invoked anywhere in the current app. When a real signup
 * form is added:
 *   - Call trackSignUpStarted() from the first field's onFocus (or the
 *     'Create account' CTA click).
 *   - Call trackSignUpCompleted(method) ONLY after the backend confirms
 *     the account was created (never on page load, never on validation fail).
 * Never pass the email, name, or password.
 */
export function trackSignUpStarted(method = 'email') {
  trackEvent('sign_up_started', { method });
}

export function trackSignUpCompleted(method = 'email') {
  trackEvent('sign_up', { method });
}
